// extracted by mini-css-extract-plugin
export var cdsAssistiveText = "Container-module--cds--assistive-text--c740b";
export var cdsVisuallyHidden = "Container-module--cds--visually-hidden--d603f";
export var hideFeedback = "Container-module--hide-feedback--d7ca1";
export var overlay = "Container-module--overlay--d2679";
export var showFeedback = "Container-module--show-feedback--5087e";
export var skeleton = "Container-module--skeleton--163bf";
export var visible = "Container-module--visible--f4596";